import { useEffect } from "react";
import { useStore } from "../../../app/data/root.store";
import { VaultDropdownCheckmarkIcon } from "../../assets/icons";
import { SORT_BY_OPTIONS } from "../../data/vault-store";
import { VaultSortDropdownItemsWrapper, VaultSortDropdownItem, VaultSortDropdownTitle, VaultSortDropdownWrapper, VaultDropdownItemCheckmarkIconWrapper } from "./VaultSortDropdown.styles";

export const VaultSortDropdown = ({ onClose }) => {
    const { vaultStore } = useStore();

    useEffect(() => {
        document.addEventListener('click', onClose);
        return () => {
            document.removeEventListener('click', onClose);
        };
    }, [onClose]);

    return (
        <VaultSortDropdownWrapper>
            <VaultSortDropdownTitle>Sort by</VaultSortDropdownTitle>
            <VaultSortDropdownItemsWrapper>
                {SORT_BY_OPTIONS.map((option, index) => {
                    const isActive = (vaultStore.sortBy ===index);
                    const handleClick = () => {
                        vaultStore.setSortBy(index);
                        onClose();
                    };

                    return (
                        <VaultSortDropdownItem
                            key={index}
                            onClick={handleClick}
                            isActive={isActive}
                        >
                            {option.label}
                            {
                                isActive &&
                                <VaultDropdownItemCheckmarkIconWrapper>
                                    <VaultDropdownCheckmarkIcon />
                                </VaultDropdownItemCheckmarkIconWrapper>
                            }
                        </VaultSortDropdownItem>
                    )
                })}
            </VaultSortDropdownItemsWrapper>
        </VaultSortDropdownWrapper>
    );
};